import { useMemo } from "preact/hooks";
import { useSignal, useSignalEffect } from "@preact/signals";
import { localBool } from "~/core";

const useLocalBool = (key: string) => {
    const { get, set } = useMemo(() => localBool(key), [key]);

    const value = useSignal(get());

    useSignalEffect(() => {
        set(value.value);
    });

    return value;
};

export default useLocalBool;
